import { NOTIFICATION_TYPES, SECTIONS } from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import {
    Empty,
    Select,
    Button,
    Breadcrumb,
    Form,
    Input,
    Divider,
    Menu,
    Spin,
    Popconfirm,
    Checkbox,
    Modal,
    DatePicker,
    DatePickerProps,
} from "antd";
import { ControlOutlined } from "@ant-design/icons";
import "./ProjectSetup.css";
import {
    PlusOutlined,
    SyncOutlined,
    CheckOutlined,
    DeleteOutlined,
    QuestionCircleOutlined,
    ExperimentOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import { UpdateEntityRequest } from "../../../../models/entities/UpdateEntityRequest";
import { CreateEntityRequest } from "../../../../models/entities/CreateEntityRequest";
import { CreateGroupCodeRequest } from "../../../../models/groupcodes/CreateGroupCodeRequest";
import { UpdateGroupCodeRequest } from "../../../../models/groupcodes/UpdateGroupCodeRequest";
import { DeleteGroupCodeRequest } from "../../../../models/groupcodes/DeleteGroupCodeRequest";
import { DeleteEntityRequest } from "../../../../models/entities/DeleteEntityRequest";
import DatabaseService from "../../../../services/databases/DatabaseService";
import { CreateDatabase } from "../../../../models/databases/CreateDatabase";
import { UpdateDatabase } from "../../../../models/databases/UpdateDatabse";
import { useTranslation } from "react-i18next";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import history from "../../../shared/utils/HistoryUtil";
import EnvironmentService from "../../../../services/environments/EnvironmentService";

import { UpdateEnvironment } from "../../../../models/environments/UpdateEnvironment";
import { CreateEnvironment } from "../../../../models/environments/CreateEnvironment";

import { UpdateReport } from "../../../../models/reports/UpdateReport";
import { CreateReport } from "../../../../models/reports/CreateReport";

import { CheckboxChangeEvent } from "antd/lib/checkbox";
import TextArea from "antd/lib/input/TextArea";
import ProjectSourceService from "../../../../services/projectsources/ProjectSourceService";
import { CreateProjectSource } from "../../../../models/projectsources/CreateProjectSource";
import { UpdateProjectSource } from "../../../../models/projectsources/UpdateProjectSource";
import { useSelector } from "react-redux";
import ExtractionService from "../../../../services/extraction/ExtractionService";
import {
    DATA_SOURCE_TYPE,
    PROJECT_TYPE,
} from "../../../../config/consts/projects";
import { ROUTES } from "../../../../config/consts/routes";
import styles from "../../operation/extraction/Extraction.module.css";
import {
    GLOBAL_COMPONENT,
    GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT,
    GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT,
    GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT,
    GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT,
    GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT,
} from "../../../../config/consts/appsettings";
import ApplicationService from "../../../../services/application/ApplicationService";
import ReportService from "../../../../services/report/ReportService";
import moment, { Moment } from "moment";
import SystemService from "../../../../services/sytem/SystemService";
import { System } from "../../../../models/system/System";
import { Entity } from "../../../../models/entities/Entity";

const routes = [
    {
        path: ROUTES.general.main.route,
        breadcrumbName: SECTIONS.general.name,
    },
    {
        breadcrumbName: SECTIONS.configuration.name,
    },
    {
        path: ROUTES.configuration.projectSetup.route,
        breadcrumbName: ROUTES.configuration.projectSetup.name,
    },
];

const ProjectSetup = () => {
    const { profile } = useSelector((state: any) => ({
        profile: state.profile,
    }));

    const { t, i18n } = useTranslation("translations");
    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [tableData, setTableData] = useState<any>([]);

    const [entities, setEntities] = useState<Entity[]>([]);
    const [groupCodes, setGroupCodes] = useState<any>([]);
    const [databases, setDatabases] = useState<any>([]);
    const [environments, setEnvironments] = useState<any>([]);
    const [entityDatabases, setEntityDatabases] = useState<any>([]);
    const [dataSources, setDataSources] = useState<any>([]);
    const [reports, setReports] = useState<any>([]);

    const [isEntitiesLoading, setIsEntitiesLoading] = useState<boolean>(false);
    const [isGroupCodesLoading, setIsGroupCodesLoading] =
        useState<boolean>(false);
    const [isDatabasesLoading, setIsDatabasesLoading] = useState<boolean>(false);
    const [isEnvironmentsLoading, setIsEnvironmentsLoading] =
        useState<boolean>(false);
    const [isDataSourcesLoading, setIsDataSourcesLoading] =
        useState<boolean>(false);
    const [isReportsLoading, setIsReportsLoading] = useState<boolean>(false);

    const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
    const [selectedEntity, setSelectedEntity] = useState<Entity>();
    const [selectedDatabase, setSelectedDatabase] = useState<any>();
    const [selectedEnvironment, setSelectedEnvironment] = useState<any>();
    const [selectedDataSource, setSelectedDataSource] = useState<any>();
    const [selectedReport, setSelectedReport] = useState<any>();

    //#region EntitySystem
    const [entitySystems, setEntitySystems] = useState<System[]>([]);

    useEffect(() => {
        SystemService.getAll()
            .then((res) => {
                setEntitySystems(res.data);
            });
    }, []);
    //#endregion

    //#region System
    const [systems, setSystems] = useState<System[]>([]);

    const [selectedSystem, setSelectedSystem] = useState<System>();

    const [systemLoading, setSystemLoading] = useState<boolean>(false);

    const [updateSystemForm] = Form.useForm<System>();

    const [createSystemForm] = Form.useForm<System>();

    useEffect(() => {
        if (selectedSystem) {
            updateSystemForm.setFieldsValue({
                id: selectedSystem.id,
                name: selectedSystem.name,
                description: selectedSystem.description,
                isPredefined: selectedSystem.isPredefined,
            });
        }
    });

    useEffect(() => {
        createSystemForm.setFieldsValue({
            id: null,
            name: "",
            description: "",
            isPredefined: false,
        });
    });

    const updateSystem = () => {
        setSystemLoading(true);
        const system: System = updateSystemForm.getFieldsValue();
        SystemService.update(selectedSystem.id, system)
            .then(() => {
                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Configuration.ProjectSetup.Notifications.System.UpdateSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "System has been successfully updated.",
                        }
                    )!,
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                setSystemLoading(false);

                SystemService.getAll().then((response) => {
                    setSystems(response.data);
                    setEntitySystems(response.data);
                    const updated = response.data.find((s: System) => s.id === selectedSystem.id);
                    setSelectedSystem(updated);
                });
            })
            .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            })
            .finally(() => {
                setSystemLoading(false);
            });
    }

    const deleteSystem = () => {
        setSystemLoading(true);
        SystemService.remove(selectedSystem.id)
            .then(() => {
                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Configuration.ProjectSetup.Notifications.System.DeleteSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "System has been successfully deleted.",
                        }
                    )!,
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                setSystemLoading(false);
                setSelectedSystem(undefined);
                updateSystemForm.resetFields();

                setSystems(systems.filter((s) => s.id !== selectedSystem.id));
                setEntitySystems(entitySystems.filter((s) => s.id !== selectedSystem.id));
            })
            .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            })
            .finally(() => {
                setSystemLoading(false);
            });
    }

    const createSystem = () => {
        setSystemLoading(true);
        const system: System = createSystemForm.getFieldsValue();
        SystemService.create(system)
            .then(() => {
                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Configuration.ProjectSetup.Notifications.System.CreateSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "System has been successfully created.",
                        }
                    )!,
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                setSystemLoading(false);
                createSystemForm.resetFields();

                SystemService.getAll().then((response) => {
                    setSystems(response.data);
                    setEntitySystems(response.data);
                });
            })
            .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            })
            .finally(() => {
                setSystemLoading(false);
            });
    };

    //#endregion

    const [testConnectionState, setTestConnectionState] = useState<any>(null);
    const [testDatabaseConnectionState, setTestDatabaseConnectionState] =
        useState<any>(null);

    const [selectedItem, setSelectedItem] = useState<any>();

    const [updateEntityDisabled, setUpdateEntityDisabled] =
        useState<boolean>(false);
    const [updateGroupCodeDisabled, setUpdateGroupCodeDisabled] =
        useState<boolean>(false);
    const [updateDatabaseDisabled, setUpdateDatabaseDisabled] =
        useState<boolean>(false);
    const [updateEnvironmentDisabled, setUpdateEnvironmentDisabled] =
        useState<boolean>(false);
    const [updateDataSourceDisabled, setUpdateDataSourceDisabled] =
        useState<boolean>(false);
    const [updateReportDisabled, setUpdateReportDisabled] =
        useState<boolean>(false);

    const [updateEntityLoading, setUpdateEntityLoading] =
        useState<boolean>(false);
    const [updateGroupCodeLoading, setUpdateGroupCodeLoading] =
        useState<boolean>(false);
    const [updateDatabaseLoading, setUpdateDatabaseLoading] =
        useState<boolean>(false);
    const [updateEnvironmentLoading, setUpdateEnvironmentLoading] =
        useState<boolean>(false);
    const [updateDataSourceLoading, setUpdateDataSourceLoading] =
        useState<boolean>(false);
    const [updateReportLoading, setUpdateReportLoading] =
        useState<boolean>(false);

    const [deleteGroupCodeLoading, setDeleteGroupCodeLoading] =
        useState<boolean>(false);
    const [deleteDatabaseLoading, setDeleteDatabaseLoading] =
        useState<boolean>(false);
    const [deleteEnvironmentLoading, setDeleteEnvironmentLoading] =
        useState<boolean>(false);
    const [deleteEntityLoading, setDeleteEntityLoading] =
        useState<boolean>(false);
    const [deleteDataSourceLoading, setDeleteDataSourceLoading] =
        useState<boolean>(false);
    const [deleteReportLoading, setDeleteReportLoading] =
        useState<boolean>(false);

    const [isDirty, setIsDirty] = useState<any>(false);

    const [preferences, setPreferences] = useState<any>([]);
    const [components, setComponents] = useState<any>([]);
    const [defaultGroupCode, setDefaultGroupCode] = useState<any>(undefined);

    const { userHasPermissions } = useSelector((state: any) => ({
        userHasPermissions: state.userHasPermissions,
    }));

    useEffect(() => {
        document.title = ROUTES.configuration.projectSetup.name;
    }, []);

    useEffect(() => {
        if (!isDirty) return;

        const unblock = history.block((tx: any) => {
            if (
                window.confirm(
                    "Are you sure you want leave the page without saving? Current changes will be lost."
                )
            ) {
                unblock();
                tx.retry();
            }
        });

        return () => {
            unblock();
        };
    }, [isDirty]);

    useEffect(() => {
        ApplicationService.getPreferences().then((response: any) => {
            const data = response.data;
            setPreferences(data);
        });
        ApplicationService.getComponents().then((response: any) => {
            const data = response.data;
            setComponents(data);
        });
    }, []);

    useEffect(() => {
        if (selectedOption) {
            setSelectedItem(undefined);
            setTableData([]);
            if (selectedOption === PROJECT_TYPE.ENTITY) {
                setSelectedGroupCode(undefined);
                setGroupCodes(null);
                setSelectedDatabase(undefined);
                setDatabases(null);
                setSelectedEnvironment(undefined);
                setEnvironments(null);
                setSelectedDataSource(undefined);
                setDataSources(null);
                setSelectedReport(undefined);
                setSelectedSystem(undefined);
                setReports(null);
                setSystems(null);

                setIsEntitiesLoading(true);
                TablesService.getAllEntities().then((response: any) => {
                    const data = response.data.sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                    setEntities(data);
                    setIsEntitiesLoading(false);
                });
                DatabaseService.getAll().then((response: any) => {
                    const data = response.data.sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                    setEntityDatabases(data);
                });
            }
            if (selectedOption === PROJECT_TYPE.GROUP_CODE) {
                setSelectedEntity(undefined);
                setEntities(null);
                setSelectedDatabase(undefined);
                setDatabases(null);
                setSelectedEnvironment(undefined);
                setEnvironments(null);
                setSelectedDataSource(undefined);
                setDataSources(null);
                setSelectedReport(undefined);
                setSelectedSystem(undefined);
                setReports(null);
                setSystems(null);

                setIsGroupCodesLoading(true);
                GroupCodesService.getAll().then((response: any) => {
                    const data = response.data.map((x: any) => ({
                        ...x,
                        startDate: x.startDate ? moment(x.startDate, "MM/DD/YYYY") : null,
                        goLiveDate: x.goLiveDate ? moment(x.goLiveDate, "MM/DD/YYYY") : null,
                        endDate: x.endDate ? moment(x.endDate, "MM/DD/YYYY") : null
                    })).sort(function (a: any, b: any) {
                        if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
                        if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
                        return 0;
                    });
                    setGroupCodes(data);
                    setIsGroupCodesLoading(false);
                });
            }
            if (selectedOption === PROJECT_TYPE.DATABASE) {
                setSelectedGroupCode(undefined);
                setGroupCodes(null);
                setSelectedEntity(undefined);
                setEntities(null);
                setSelectedEnvironment(undefined);
                setEnvironments(null);
                setSelectedDataSource(undefined);
                setDataSources(null);
                setSelectedReport(undefined);
                setSelectedSystem(undefined);
                setReports(null);
                setSystems(null);

                setIsDatabasesLoading(true);
                DatabaseService.getAll().then((response: any) => {
                    const data = response.data.sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                    setDatabases(data);
                    setIsDatabasesLoading(false);
                });
            }
            if (selectedOption === PROJECT_TYPE.ENVIRONMENT) {
                setSelectedGroupCode(undefined);
                setGroupCodes(null);
                setSelectedEntity(undefined);
                setEntities(null);
                setSelectedDatabase(undefined);
                setDatabases(null);
                setSelectedDataSource(undefined);
                setDataSources(null);
                setSelectedReport(undefined);
                setSelectedSystem(undefined);
                setReports(null);
                setSystems(null);

                setIsEnvironmentsLoading(true);
                EnvironmentService.getAll().then((response: any) => {
                    const data = response.data.sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                    setEnvironments(data);
                    setIsEnvironmentsLoading(false);
                });
            }
            if (selectedOption === PROJECT_TYPE.DATA_SOURCE) {
                setSelectedGroupCode(undefined);
                setGroupCodes(null);
                setSelectedEntity(undefined);
                setEntities(null);
                setSelectedDatabase(undefined);
                setDatabases(null);
                setSelectedEnvironment(undefined);
                setEnvironments(null);
                setSelectedReport(undefined);
                setSelectedSystem(undefined);
                setReports(null);
                setSystems(null);

                setIsDataSourcesLoading(true);
                ProjectSourceService.getAll().then((response: any) => {
                    const data = response.data.sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                    setDataSources(
                        data.map((x: any) => ({
                            ...x,
                            sourceTypeId: x.sourceTypeID.toString(),
                            tenantId:
                                x.database?.split("|||").length > 0
                                    ? x.database?.split("|||")[0]
                                    : "",
                            clientId:
                                x.database?.split("|||").length > 1
                                    ? x.database?.split("|||")[1]
                                    : "",
                        }))
                    );
                    setIsDataSourcesLoading(false);
                });
            }
            if (selectedOption === PROJECT_TYPE.REPORTING) {
                setSelectedGroupCode(undefined);
                setGroupCodes(null);
                setSelectedEntity(undefined);
                setEntities(null);
                setSelectedDatabase(undefined);
                setDatabases(null);
                setSelectedEnvironment(undefined);
                setEnvironments(null);
                setSelectedDataSource(undefined);
                setSelectedSystem(undefined);
                setDataSources(null);
                setSystems(null);

                setIsReportsLoading(true);
                ReportService.getAll().then((response: any) => {
                    const data = response.data.sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                    setReports(data);
                    setIsReportsLoading(false);
                });
            }
            if (selectedOption === PROJECT_TYPE.SYSTEM) {
                setEntities(null);
                setGroupCodes(null);
                setDatabases(null);
                setEnvironments(null);
                setDataSources(null);

                setSelectedEntity(undefined);
                setSelectedGroupCode(undefined);
                setSelectedDatabase(undefined);
                setSelectedEnvironment(undefined);
                setSelectedDataSource(undefined);

                setIsReportsLoading(true);
                SystemService.getAll().then((response) => {
                    setSystems(response.data);
                    setIsReportsLoading(false);
                });
            }
        } else {
            setEntities([]);
            setGroupCodes([]);
            setDatabases([]);
            setEnvironments([]);
            setDataSources([]);
            setSelectedEntity(undefined);
            setSelectedGroupCode(undefined);
            setSelectedDatabase(undefined);
            setSelectedEnvironment(undefined);
            setSelectedDataSource(undefined);
        }
    }, [selectedOption]);

    useEffect(() => {
        if (entities) {
            setTableData(entities);
        }
        if (groupCodes) {
            setTableData(groupCodes);
        }
        if (databases) {
            setTableData(databases);
        }
        if (environments) {
            setTableData(environments);
        }
        if (dataSources) {
            setTableData(dataSources);
        }
        if (reports) {
            setTableData(reports);
        }
        if (systems) {
            setTableData(systems);
        }
    }, [entities, groupCodes, databases, environments, dataSources, reports, systems]);

    useEffect(() => {
        if (tableData && tableData.length === 1) {
            handleOptionMenuClick({ key: tableData[0].id.toString() });
        }
    }, [tableData]);

    useEffect(() => {
        if (
            preferences?.length > 0 &&
            components?.length > 0 &&
            profile &&
            groupCodes?.length > 0 &&
            !defaultGroupCode
        ) {
            const existingPreference = preferences.find(
                (x) =>
                    x.componentId ===
                    components.find((x: any) => x.name === GLOBAL_COMPONENT)?.id &&
                    x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
                    x.object === "User" &&
                    x.objectId.toString() === profile.id.toString()
            );

            if (existingPreference) {
                setDefaultGroupCode(existingPreference.value);
                // .setFieldsValue({ defaultGroupCode: existingPreference.value });
            }
        }
    }, [preferences, components, profile, groupCodes]);

    const handleOptionChange = (value: string) => {
        setSelectedOption(value);
        setIsDirty(false);
    };

    const handleOptionMenuClick = (e: any) => {
        const val = tableData.find((x: any) => x.id.toString() === e.key);
        setSelectedItem(val);
        setIsDirty(false);

        if (selectedOption === PROJECT_TYPE.ENTITY) {
            setSelectedEntity(val);
            setSelectedGroupCode(null);
        }
        if (selectedOption === PROJECT_TYPE.GROUP_CODE) {
            setSelectedGroupCode(val);
            setSelectedEntity(null);
        }
        if (selectedOption === PROJECT_TYPE.DATABASE) {
            setSelectedDatabase(val);
            setSelectedEnvironment(null);
            setSelectedGroupCode(null);
            setSelectedEntity(null);
            setSelectedDataSource(null);
        }
        if (selectedOption === PROJECT_TYPE.ENVIRONMENT) {
            setSelectedEnvironment(val);
            setSelectedDatabase(null);
            setSelectedGroupCode(null);
            setSelectedEntity(null);
            setSelectedDataSource(null);
        }
        if (selectedOption === PROJECT_TYPE.DATA_SOURCE) {
            setSelectedDataSource(val);
            setSelectedEnvironment(null);
            setSelectedDatabase(null);
            setSelectedGroupCode(null);
            setSelectedEntity(null);
        }
        if (selectedOption === PROJECT_TYPE.REPORTING) {
            setSelectedReport(val);
            setSelectedDataSource(null);
            setSelectedEnvironment(null);
            setSelectedDatabase(null);
            setSelectedGroupCode(null);
            setSelectedEntity(null);
        }
        if (selectedOption === PROJECT_TYPE.SYSTEM) {
            setSelectedSystem(val);
            setSelectedDataSource(null);
            setSelectedEnvironment(null);
            setSelectedDatabase(null);
            setSelectedGroupCode(null);
            setSelectedEntity(null);
        }
    };

    const onAddClick = (e: any) => {
        setSelectedItem(undefined);
        setIsDirty(true);
        if (selectedOption === PROJECT_TYPE.ENTITY) {
            setSelectedEntity({
                id: null,
                name: "",
                description: "",
                defaultImportDatabase: entityDatabases.length === 1 ? entityDatabases[0].name : null,
                defaultLegacyDatabase: entityDatabases.length === 1 ? entityDatabases[0].name : null,
                defaultValidationDatabase: entityDatabases.length === 1 ? entityDatabases[0].name : null,
                defaultLoadFileDatabase: entityDatabases.length === 1 ? entityDatabases[0].name : null,
                targetSystemId: null,
                legacySystemId: null,
                sourceSystemIds: [],
                alwaysShow: false,
                defaultDatabase:
                    entityDatabases.length === 1 ? entityDatabases[0].name : null,
            });
        }
        if (selectedOption === PROJECT_TYPE.GROUP_CODE) {
            setSelectedGroupCode({ id: "New Group code", code: "", active: true });
        }
        if (selectedOption === PROJECT_TYPE.DATABASE) {
            setSelectedDatabase({ id: "New Database", name: "" });
        }
        if (selectedOption === PROJECT_TYPE.ENVIRONMENT) {
            setSelectedEnvironment({
                id: "New Environment",
                name: "",
                description: "",
                isDefault: false,
            });
        }
        if (selectedOption === PROJECT_TYPE.DATA_SOURCE) {
            setSelectedDataSource({ id: "New Data Source", name: "" });
        }
        if (selectedOption === PROJECT_TYPE.REPORTING) {
            setSelectedReport({ id: "New Report", name: "", url: "" });
        }
        if (selectedOption === PROJECT_TYPE.SYSTEM) {
            setSelectedSystem({ id: null, name: "", description: "", isPredefined: false });
        }
    };

    const onSelectedGroupCodeCodeChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        if (/^[A-Za-z0-9_]*$/.test(event.target.value)) {
            setSelectedGroupCode({
                ...selectedGroupCode,
                code: event.target.value.replace(/\s/g, ""),
            });
        }
    };

    const onSelectedGroupCodeLabelChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedGroupCode({ ...selectedGroupCode, label: event.target.value });
    };

    const onSelectedGroupCodeStartDateChange: DatePickerProps['onChange'] = (date: Moment, dateString: string) => {
        setSelectedGroupCode({ ...selectedGroupCode, startDate: date });
    };

    const onSelectedGroupCodeGoLiveDateChange: DatePickerProps['onChange'] = (date: Moment, dateString: string) => {
        setSelectedGroupCode({ ...selectedGroupCode, goLiveDate: date });
    };

    const onSelectedGroupCodeEndDateChange: DatePickerProps['onChange'] = (date: Moment, dateString: string) => {
        setSelectedGroupCode({ ...selectedGroupCode, endDate: date });
    };

    const onSelectedGroupCodeIsActiveChange = (event: CheckboxChangeEvent) => {
        setSelectedGroupCode({
            ...selectedGroupCode,
            active: event.target.checked,
        });
    };

    const onSelectedDefaultGroupCodeIsActiveChange = (
        event: CheckboxChangeEvent
    ) => {
        if (event.target.checked) {
            setDefaultGroupCode(selectedGroupCode.code);
            saveDefaultGroupCode(selectedGroupCode.code);
            return;
        }
        setDefaultGroupCode(undefined);
        saveDefaultGroupCode(undefined);
    };

    const onSelectedEntityNameChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        if (/^[A-Za-z0-9_]*$/.test(event.target.value)) {
            setSelectedEntity({
                ...selectedEntity,
                name: event.target.value.replace(/\s/g, ""),
            });
        }
    };

    const onSelectedDatabaseNameChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        if (/^[A-Za-z0-9_]*$/.test(event.target.value)) {
            setSelectedDatabase({
                ...selectedDatabase,
                name: event.target.value.replace(/\s/g, ""),
            });
        }
    };

    const onSelectedDatabaseDescriptionChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDatabase({
            ...selectedDatabase,
            description: event.target.value,
        });
    };

    const onSelectedDatabaseIsDefaultImportDbChange = (
        event: CheckboxChangeEvent
    ) => {
        setSelectedDatabase({
            ...selectedDatabase,
            isDefaultImportDB: event.target.checked,
        });
    };

    const onSelectedDatabaseIsDefaultLegacyDbChange = (
        event: CheckboxChangeEvent
    ) => {
        setSelectedDatabase({
            ...selectedDatabase,
            isDefaultLegacyDB: event.target.checked,
        });
    };

    const onSelectedDatabaseIsDefaultValidationDbChange = (
        event: CheckboxChangeEvent
    ) => {
        setSelectedDatabase({
            ...selectedDatabase,
            isDefaultValidationDB: event.target.checked,
        });
    };

    const onSelectedDatabaseIsDefaultLoadfileDbChange = (
        event: CheckboxChangeEvent
    ) => {
        setSelectedDatabase({
            ...selectedDatabase,
            isDefaultLoadfileDB: event.target.checked,
        });
    };

    const onSelectedEnvironmentNameChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        if (/^[A-Za-z0-9_]*$/.test(event.target.value)) {
            setSelectedEnvironment({
                ...selectedEnvironment,
                name: event.target.value.replace(/\s/g, ""),
            });
        }
    };

    const onSelectedEnvironmentDescriptionChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedEnvironment({
            ...selectedEnvironment,
            description: event.target.value,
        });
    };

    const onSelectedEnvironmentIsDefaultChange = (e: CheckboxChangeEvent) => {
        const newIsDefault = e.target.checked;
        const currentDefaultEnvironment = environments.find((env) => env.isDefault);

        if (
            currentDefaultEnvironment &&
            currentDefaultEnvironment.id !== selectedEnvironment.id
        ) {
            Modal.confirm({
                title: "Change Default Environment",
                content: `This will change the default environment from '${currentDefaultEnvironment.name}' to '${selectedEnvironment.name}'. Do you want to continue?`,
                onOk: () => {
                    setEnvironments((prevEnvironments) =>
                        prevEnvironments.map((env) =>
                            env.id === currentDefaultEnvironment.id
                                ? { ...env, isDefault: false }
                                : env
                        )
                    );
                    setSelectedEnvironment((prevState) => ({
                        ...prevState,
                        isDefault: newIsDefault,
                    }));
                },
                onCancel: () => {
                    setSelectedEnvironment((prevState) => ({
                        ...prevState,
                        isDefault: !newIsDefault,
                    }));
                },
            });
        } else {
            // No other default environment or the same environment is selected
            setSelectedEnvironment((prevState) => ({
                ...prevState,
                isDefault: newIsDefault,
            }));
        }
    };

    const onSelectedReportIsDefaultChange = (e: CheckboxChangeEvent) => {
        const newIsDefault = e.target.checked;
        const currentDefaultReport = reports.find((env) => env.isDefault);

        if (currentDefaultReport && currentDefaultReport.id !== selectedReport.id) {
            Modal.confirm({
                title: "Change Default Report",
                content: `This will change the default report from '${currentDefaultReport.name}' to '${selectedReport.name}'. Do you want to continue?`,
                onOk: () => {
                    setReports((prevReports) =>
                        prevReports.map((env) =>
                            env.id === currentDefaultReport.id
                                ? { ...env, isDefault: false }
                                : env
                        )
                    );
                    setSelectedReport((prevState) => ({
                        ...prevState,
                        isDefault: newIsDefault,
                    }));
                },
                onCancel: () => {
                    setSelectedReport((prevState) => ({
                        ...prevState,
                        isDefault: !newIsDefault,
                    }));
                },
            });
        } else {
            // No other default report or the same report is selected
            setSelectedReport((prevState) => ({
                ...prevState,
                isDefault: newIsDefault,
            }));
        }
    };

    const onSelectedDataSourceNameChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            name: event.target.value,
        });
    };

    const onSelectedDataSourceServerChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            server: event.target.value,
        });
    };

    const onSelectedDataSourceDatabaseChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            database: event.target.value,
        });
    };

    const onSelectedTenantIdChange: React.ChangeEventHandler<HTMLInputElement> = (
        event
    ) => {
        setSelectedDataSource({
            ...selectedDataSource,
            tenantId: event.target.value,
            database: `${event.target.value}|||${selectedDataSource.clientId ?? ""}`,
        });
    };

    const onSelectedClientIdChange: React.ChangeEventHandler<HTMLInputElement> = (
        event
    ) => {
        setSelectedDataSource({
            ...selectedDataSource,
            clientId: event.target.value,
            database: `${selectedDataSource.tenantId ?? ""}|||${event.target.value}`,
        });
    };

    const onSelectedDataSourceUsernameChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            username: event.target.value,
        });
    };

    const onSelectedDataSourcePasswordChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            password: event.target.value,
        });
    };

    const onSelectedDataSourceSourcePrefixChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            sourcePrefix: event.target.value,
        });
    };

    const onSelectedDataSourceLocationPathChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedDataSource({
            ...selectedDataSource,
            locationPath: event.target.value,
        });
    };

    const onSelectedReportNameChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedReport({
            ...selectedReport,
            name: event.target.value,
        });
    };

    const onSelectedReportURLChange: React.ChangeEventHandler<
        HTMLInputElement
    > = (event) => {
        setSelectedReport({
            ...selectedReport,
            url: event.target.value,
        });
    };

    useEffect(() => {
        if (selectedEntity && tableData) {
            const current = JSON.stringify(selectedEntity);
            const def = JSON.stringify(
                tableData.find((x: any) => x.id === selectedEntity.id)
            );

            if (current !== def) {
                setUpdateEntityDisabled(false);
                setIsDirty(true);
            } else {
                setUpdateEntityDisabled(true);
                setIsDirty(false);
            }
        } else {
            setUpdateEntityDisabled(false);
        }
    }, [selectedEntity, tableData]);

    useEffect(() => {
        if (selectedGroupCode && tableData) {
            const current = JSON.stringify(selectedGroupCode);
            const def = JSON.stringify(
                tableData.find((x: any) => x.id === selectedGroupCode.id)
            );
            if (current !== def) {
                setUpdateGroupCodeDisabled(false);
                setIsDirty(true);
            } else {
                setUpdateGroupCodeDisabled(true);
                setIsDirty(false);
            }
        } else {
            setUpdateGroupCodeDisabled(false);
        }
    }, [selectedGroupCode, tableData]);

    useEffect(() => {
        if (selectedDatabase && tableData) {
            const current = JSON.stringify(selectedDatabase);
            const def = JSON.stringify(
                tableData.find((x: any) => x.id === selectedDatabase.id)
            );

            if (current !== def) {
                setUpdateDatabaseDisabled(false);
                setIsDirty(true);
            } else {
                setUpdateDatabaseDisabled(true);
                setIsDirty(false);
            }
        }
    }, [selectedDatabase, tableData]);

    useEffect(() => {
        if (selectedEnvironment && tableData) {
            const current = JSON.stringify(selectedEnvironment);
            const def = JSON.stringify(
                tableData.find((x: any) => x.id === selectedEnvironment.id)
            );

            if (current !== def) {
                setUpdateEnvironmentDisabled(false);
                setIsDirty(true);
            } else {
                setUpdateEnvironmentDisabled(true);
                setIsDirty(false);
            }
        }
    }, [selectedEnvironment, tableData]);

    useEffect(() => {
        if (selectedDataSource && tableData) {
            setTestConnectionState(undefined);

            const current = JSON.stringify(selectedDataSource);
            const def = JSON.stringify(
                tableData.find((x: any) => x.id === selectedDataSource.id)
            );

            if (current !== def) {
                setUpdateDataSourceDisabled(false);
                setIsDirty(true);
            } else {
                setUpdateDataSourceDisabled(true);
                setIsDirty(false);
            }
        }
    }, [selectedDataSource, tableData]);

    useEffect(() => {
        if (selectedReport && tableData) {
            const current = JSON.stringify(selectedReport);
            const def = JSON.stringify(
                tableData.find((x: any) => x.id === selectedReport.id)
            );

            if (current !== def) {
                setUpdateReportDisabled(false);
                setIsDirty(true);
            } else {
                setUpdateReportDisabled(true);
                setIsDirty(false);
            }
        }
    }, [selectedReport, tableData]);

    const saveDefaultGroupCode = (groupCode: string) => {
        const existingPreference = preferences.find(
            (x) =>
                x.componentId ===
                components.find((x: any) => x.name === GLOBAL_COMPONENT)?.id &&
                x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
                x.object === "User" &&
                x.objectId.toString() === profile.id.toString()
        );

        if (!groupCode && existingPreference) {
            ApplicationService.deletePreference(existingPreference.id)
                .then((response: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: t(
                            "Page.Administration.Account.Preferences.GroupCodePreferenceUpdateSuccessDescription",
                            {
                                lngs: i18n.languages,
                                defaultValue: "GroupCode preference successfully saved",
                            }
                        )!,
                        type: NOTIFICATION_TYPES.SUCCESS,
                        logError: false,
                    });
                })
                .catch((error: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: error.response.data,
                        type: NOTIFICATION_TYPES.ERROR,
                        logError: true,
                    });
                });
            return;
        }

        if (!groupCode) {
            return;
        }

        let model: any = {
            componentId: components.find((x: any) => x.name === GLOBAL_COMPONENT)?.id,
            key: GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT,
            object: "User",
            objectId: profile.id.toString(),
            value: groupCode,
        };

        if (existingPreference) {
            ApplicationService.updatePreference(existingPreference.id, model).then(
                (response: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: t(
                            "Page.Administration.Account.Preferences.GroupCodePreferenceUpdateSuccessDescription",
                            {
                                lngs: i18n.languages,
                                defaultValue: "GroupCode preference successfully saved",
                            }
                        )!,
                        placement: "bottomRight",
                        type: NOTIFICATION_TYPES.SUCCESS,
                        logError: false,
                    });
                    ApplicationService.getPreferences().then((response: any) => {
                        const data = response.data;
                        setPreferences(data);
                    });
                }
            );
        } else {
            ApplicationService.createPreference(model).then((response: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Administration.Account.Preferences.GroupCodePreferenceUpdateSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "GroupCode preference successfully saved",
                        }
                    )!,
                    placement: "bottomRight",
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                ApplicationService.getPreferences().then((response: any) => {
                    const data = response.data;
                    setPreferences(data);
                });
            });
        }
    };

    const createEntity = async () => {
        setUpdateEntityLoading(true);
        const model: CreateEntityRequest = {
            name: selectedEntity.name,
            description: selectedEntity.description,
            defaultImportDatabase: selectedEntity.defaultImportDatabase,
            defaultLegacyDatabase: selectedEntity.defaultLegacyDatabase,
            defaultValidationDatabase: selectedEntity.defaultValidationDatabase,
            defaultLoadFileDatabase: selectedEntity.defaultLoadFileDatabase,
            alwaysShow: selectedEntity.alwaysShow,
            sourceSystemIds: selectedEntity.sourceSystemIds,
            targetSystemId: selectedEntity.targetSystemId,
            legacySystemId: selectedEntity.legacySystemId,
        };

        try {
            const existingEntity = entities.find(
                (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
            );
            if (existingEntity && existingEntity.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Entity with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateEntityLoading(false);
                return;
            }

            await TablesService.createEntity(model);
            const entitiesData = await TablesService.getAllEntities().then(
                (response: any) => response.data
            );
            setEntities(
                entitiesData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Entity.CreateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Entity has been successfully created.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateEntityLoading(false);
        }
    };

    const updateEntity = async () => {
        setUpdateEntityLoading(true);
        const model: UpdateEntityRequest = {
            id: selectedEntity.id,
            name: selectedEntity.name,
            description: selectedEntity.description,
            defaultImportDatabase: selectedEntity.defaultImportDatabase,
            defaultLegacyDatabase: selectedEntity.defaultLegacyDatabase,
            defaultValidationDatabase: selectedEntity.defaultValidationDatabase,
            defaultLoadFileDatabase: selectedEntity.defaultLoadFileDatabase,
            alwaysShow: selectedEntity.alwaysShow,
            sourceSystemIds: selectedEntity.sourceSystemIds,
            targetSystemId: selectedEntity.targetSystemId,
            legacySystemId: selectedEntity.legacySystemId,
        };

        try {
            const existingEntity = entities.find(
                (x: any) =>
                    x.name.toLowerCase() === model.name.toLowerCase() && x.id !== model.id
            );
            if (existingEntity && existingEntity.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Entity with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateEntityLoading(false);
                return;
            }

            await TablesService.updateEntity(model);
            const entitiesData = await TablesService.getAllEntities().then(
                (response: any) => response.data
            );
            setEntities(
                entitiesData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Entity.UpdateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Entity has been successfully updated.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateEntityLoading(false);
        }
    };

    const deleteEntity = async () => {
        setDeleteEntityLoading(true);
        const model: DeleteEntityRequest = {
            id: selectedEntity.id,
        };

        try {
            await TablesService.deleteEntity(model);
            setSelectedItem(undefined);
            setSelectedEntity(undefined);
            const entitiesData = await TablesService.getAllEntities().then(
                (response: any) => response.data
            );
            setEntities(
                entitiesData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Entity.DeleteSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Entity has been successfully deleted.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setDeleteEntityLoading(false);
        }
    };

    const createGroupCode = async () => {
        setUpdateGroupCodeLoading(true);
        const model: CreateGroupCodeRequest = {
            code: selectedGroupCode.code,
            label: selectedGroupCode.label,
            active: selectedGroupCode.active,
            startDate: selectedGroupCode.startDate,
            goLiveDate: selectedGroupCode.goLiveDate,
            endDate: selectedGroupCode.endDate,
        };

        try {
            const existingGroupCode = groupCodes.find(
                (x: any) => x.code.toLowerCase() === model.code.toLowerCase()
            );
            if (existingGroupCode && existingGroupCode.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Group code with a same name '${model.code}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateGroupCodeLoading(false);
                return;
            }

            const response = await GroupCodesService.create(model).then(
                (response: any) => response.data
            );
            const groupCodesData = await GroupCodesService.getAll().then(
                (response: any) => response.data.map((x: any) => ({
                    ...x,
                    startDate: x.startDate ? moment(x.startDate, "MM/DD/YYYY") : null,
                    goLiveDate: x.goLiveDate ? moment(x.goLiveDate, "MM/DD/YYYY") : null,
                    endDate: x.endDate ? moment(x.endDate, "MM/DD/YYYY") : null
                }))
            );
            setGroupCodes(
                groupCodesData.sort(function (a: any, b: any) {
                    if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
                    if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.GroupCode.CreateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Group code has been successfully created.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateGroupCodeLoading(false);
        }
    };

    const updateGroupCode = async () => {
        setUpdateGroupCodeLoading(true);
        const model: UpdateGroupCodeRequest = {
            id: selectedGroupCode.id,
            code: selectedGroupCode.code,
            label: selectedGroupCode.label,
            active: selectedGroupCode.active,
            startDate: selectedGroupCode.startDate,
            goLiveDate: selectedGroupCode.goLiveDate,
            endDate: selectedGroupCode.endDate,
        };

        try {
            const existingGroupCode = groupCodes.find(
                (x: any) =>
                    x.code.toLowerCase() === model.code.toLowerCase() && x.id !== model.id
            );
            if (existingGroupCode && existingGroupCode.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Group code with a same name '${model.code}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateGroupCodeLoading(false);
                return;
            }

            await GroupCodesService.update(model);
            const groupCodesData = await GroupCodesService.getAll().then(
                (response: any) => response.data.map((x: any) => ({
                    ...x,
                    startDate: x.startDate ? moment(x.startDate, "MM/DD/YYYY") : null,
                    goLiveDate: x.goLiveDate ? moment(x.goLiveDate, "MM/DD/YYYY") : null,
                    endDate: x.endDate ? moment(x.endDate, "MM/DD/YYYY") : null
                }))
            );
            setGroupCodes(
                groupCodesData.sort(function (a: any, b: any) {
                    if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
                    if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.GroupCode.UpdateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Group code has been successfully updated.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateGroupCodeLoading(false);
        }
    };

    const deleteGroupCode = async () => {
        setDeleteGroupCodeLoading(true);
        const model: DeleteGroupCodeRequest = {
            id: selectedGroupCode.id,
        };

        try {
            await GroupCodesService.remove(model);
            setSelectedGroupCode(undefined);
            setSelectedEntity(undefined);
            const groupCodesData = await GroupCodesService.getAll().then(
                (response: any) => response.data.map((x: any) => ({
                    ...x,
                    startDate: x.startDate ? moment(x.startDate, "MM/DD/YYYY") : null,
                    goLiveDate: x.goLiveDate ? moment(x.goLiveDate, "MM/DD/YYYY") : null,
                    endDate: x.endDate ? moment(x.endDate, "MM/DD/YYYY") : null
                }))
            );
            setGroupCodes(
                groupCodesData.sort(function (a: any, b: any) {
                    if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
                    if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.GroupCode.DeleteSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Group code has been successfully deleted.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setDeleteGroupCodeLoading(false);
        }
    };

    const createDatabase = async () => {
        setUpdateDatabaseLoading(true);
        const model: CreateDatabase = {
            name: selectedDatabase.name,
            description: selectedDatabase.description,
            isDefaultImportDB: selectedDatabase.isDefaultImportDB,
            isDefaultLegacyDB: selectedDatabase.isDefaultLegacyDB,
            isDefaultValidationDB: selectedDatabase.isDefaultValidationDB,
            isDefaultLoadfileDB: selectedDatabase.isDefaultLoadfileDB,
        };

        try {
            const existingDatabase = databases.find(
                (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
            );
            if (existingDatabase && existingDatabase.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Database with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateDatabaseLoading(false);
                return;
            }

            await DatabaseService.create(model).then(
                (response: any) => response.data
            );
            // const roles = getEditedGroupCodeRoles(response.data);
            // await TablesService.updateGroupCodeAccessRights(roles);
            const databaseData = await DatabaseService.getAll().then(
                (response: any) => response.data
            );
            setDatabases(
                databaseData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Database.CreateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Database has been successfully created.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateDatabaseLoading(false);
        }
    };

    const updateDatabase = async () => {
        setUpdateDatabaseLoading(true);
        const model: UpdateDatabase = {
            id: selectedDatabase.id,
            name: selectedDatabase.name,
            description: selectedDatabase.description,
            isDefaultImportDB: selectedDatabase.isDefaultImportDB,
            isDefaultLegacyDB: selectedDatabase.isDefaultLegacyDB,
            isDefaultValidationDB: selectedDatabase.isDefaultValidationDB,
            isDefaultLoadfileDB: selectedDatabase.isDefaultLoadfileDB,
        };

        try {
            const existingDatabase = databases.find(
                (x: any) =>
                    x.name.toLowerCase() === model.name.toLowerCase() && x.id !== model.id
            );
            if (existingDatabase && existingDatabase.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Database with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateDatabaseLoading(false);
                return;
            }

            await DatabaseService.update(model);
            // const roles = getEditedGroupCodeRoles(model.id);
            // await TablesService.updateGroupCodeAccessRights(roles);
            const databaseData = await DatabaseService.getAll().then(
                (response: any) => response.data
            );
            setDatabases(
                databaseData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Database.UpdateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Database has been successfully updated.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateDatabaseLoading(false);
        }
    };

    const deleteDatabase = async () => {
        setDeleteDatabaseLoading(true);

        try {
            await DatabaseService.remove(selectedDatabase.id);
            setSelectedGroupCode(undefined);
            setSelectedEntity(undefined);
            setSelectedDatabase(undefined);
            setSelectedEnvironment(undefined);
            const databasedata = await DatabaseService.getAll().then(
                (response: any) => response.data
            );
            setDatabases(
                databasedata.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Database.DeleteSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Database has been successfully deleted.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setDeleteDatabaseLoading(false);
        }
    };

    const createEnvironment = async () => {
        setUpdateEnvironmentLoading(true);
        const model: CreateEnvironment = {
            name: selectedEnvironment.name,
            description: selectedEnvironment.description,
            isDefault: selectedEnvironment.isDefault,
        };

        try {
            const existingEnvironment = environments.find(
                (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
            );
            if (existingEnvironment && existingEnvironment.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Environment with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateEnvironmentLoading(false);
                return;
            }

            await EnvironmentService.create(model).then(
                (response: any) => response.data
            );
            // const roles = getEditedGroupCodeRoles(response.data);
            // await TablesService.updateGroupCodeAccessRights(roles);
            const environmentData = await EnvironmentService.getAll().then(
                (response: any) => response.data
            );
            setEnvironments(
                environmentData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Environment.CreateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Environment has been successfully created.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateEnvironmentLoading(false);
        }
    };

    const updateEnvironment = async () => {
        setUpdateEnvironmentLoading(true);
        const model: UpdateEnvironment = {
            id: selectedEnvironment.id,
            name: selectedEnvironment.name,
            description: selectedEnvironment.description,
            isDefault: selectedEnvironment.isDefault,
        };

        try {
            const existingEnvironment = environments.find(
                (x: any) =>
                    x.name.toLowerCase() === model.name.toLowerCase() && x.id !== model.id
            );
            if (existingEnvironment && existingEnvironment.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Environment with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateEnvironmentLoading(false);
                return;
            }

            await EnvironmentService.update(model);
            // const roles = getEditedGroupCodeRoles(model.id);
            // await TablesService.updateGroupCodeAccessRights(roles);
            const environmentData = await EnvironmentService.getAll().then(
                (response: any) => response.data
            );
            setEnvironments(
                environmentData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Environment.UpdateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Environment has been successfully updated.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateEnvironmentLoading(false);
        }
    };

    const deleteEnvironment = async () => {
        setDeleteEnvironmentLoading(true);

        try {
            await EnvironmentService.remove(selectedEnvironment.id);
            setSelectedGroupCode(undefined);
            setSelectedEntity(undefined);
            setSelectedEnvironment(undefined);
            setSelectedDatabase(undefined);
            const environmentData = await EnvironmentService.getAll().then(
                (response: any) => response.data
            );
            setEnvironments(
                environmentData.sort(function (a: any, b: any) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Environment.DeleteSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Environment has been successfully deleted.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setDeleteEnvironmentLoading(false);
        }
    };

    const createDataSource = async () => {
        setUpdateDataSourceLoading(true);
        const model: CreateProjectSource = {
            name: selectedDataSource.name,
            sourceTypeId: selectedDataSource.sourceTypeId,
            server: selectedDataSource.server,
            database: selectedDataSource.database,
            username: selectedDataSource.username,
            password: selectedDataSource.password,
            locationPath: selectedDataSource.locationPath,
            sourcePrefix: selectedDataSource.sourcePrefix,
        };

        try {
            const existingDataSource = dataSources.find(
                (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
            );
            if (existingDataSource && existingDataSource.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Project data source with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateDataSourceLoading(false);
                return;
            }

            await ProjectSourceService.create(model).then(
                (response: any) => response.data
            );
            // const roles = getEditedGroupCodeRoles(response.data);
            // await TablesService.updateGroupCodeAccessRights(roles);
            const dataSourceData = await ProjectSourceService.getAll().then(
                (response: any) => response.data
            );
            setDataSources(
                dataSourceData
                    .sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    })
                    .map((x: any) => ({
                        ...x,
                        sourceTypeId: x.sourceTypeID.toString(),
                    }))
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.DataSource.CreateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Data source has been successfully created.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateDataSourceLoading(false);
        }
    };

    const updateDataSource = async () => {
        setUpdateDataSourceLoading(true);
        const model: UpdateProjectSource = {
            id: selectedDataSource.id,
            name: selectedDataSource.name,
            sourceTypeId: selectedDataSource.sourceTypeId,
            server: selectedDataSource.server,
            database: selectedDataSource.database,
            username: selectedDataSource.username,
            password: selectedDataSource.password,
            locationPath: selectedDataSource.locationPath,
            sourcePrefix: selectedDataSource.sourcePrefix,
        };

        try {
            const existingDataSource = dataSources.find(
                (x: any) =>
                    x.name.toLowerCase() === model.name.toLowerCase() && x.id !== model.id
            );
            if (existingDataSource && existingDataSource.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Project data source with a same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateDataSourceLoading(false);
                return;
            }

            await ProjectSourceService.update(model);
            // const roles = getEditedGroupCodeRoles(model.id);
            // await TablesService.updateGroupCodeAccessRights(roles);
            const dataSourceData = await ProjectSourceService.getAll().then(
                (response: any) => response.data
            );
            setDataSources(
                dataSourceData
                    .sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    })
                    .map((x: any) => ({
                        ...x,
                        sourceTypeId: x.sourceTypeID.toString(),
                    }))
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.DataSource.UpdateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Project data source has been successfully updated.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateDataSourceLoading(false);
        }
    };

    const testSharePointConnection = async () => {
        ExtractionService.testSharePointConnection(
            selectedDataSource.id,
            selectedDataSource.server,
            selectedDataSource.database?.split("|||")[0],
            selectedDataSource.database?.split("|||")[1],
            selectedDataSource.username,
            selectedDataSource.password ?? ""
        ).then((response) => {
            setTestConnectionState(response.data);
        });
    };

    const deleteDataSource = async () => {
        setDeleteDataSourceLoading(true);

        try {
            await ProjectSourceService.remove(selectedDataSource.id);
            setSelectedGroupCode(undefined);
            setSelectedEntity(undefined);
            setSelectedEnvironment(undefined);
            setSelectedDatabase(undefined);
            setSelectedDataSource(undefined);
            const dataSourceData = await ProjectSourceService.getAll().then(
                (response: any) => response.data
            );
            setDataSources(
                dataSourceData
                    .sort(function (a: any, b: any) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    })
                    .map((x: any) => ({
                        ...x,
                        sourceTypeId: x.sourceTypeID.toString(),
                    }))
            );
            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.DataSource.DeleteSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Project data source has been successfully deleted.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setDeleteDataSourceLoading(false);
        }
    };

    const createReport = async () => {
        setUpdateReportLoading(true);

        const model: CreateReport = {
            name: selectedReport.name,
            url: selectedReport.url,
            isDefault: selectedReport.isDefault,
        };

        try {
            const existingReport = reports.find(
                (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
            );
            if (existingReport && existingReport.id !== -1) {
                NotificationsUtil.openNotificationDialog({
                    description: `Report with the same name '${model.name}' already exists. Please use a different name.`,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
                setUpdateReportLoading(false);
                return;
            }

            await ReportService.create(model).then((response: any) => response.data);
            const reportData = await ReportService.getAll().then(
                (response: any) => response.data
            );

            setReports(
                reportData.sort((a: any, b: any) =>
                    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                )
            );

            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Report.CreateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Report has been successfully created.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });

            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setUpdateReportLoading(false);
        }
    };

    const updateReport = async () => {
        try {
            const model: UpdateReport = {
                id: selectedReport.id,
                name: selectedReport.name,
                url: selectedReport.url,
                isDefault: selectedReport.isDefault,
            };

            await ReportService.update(model);

            const updatedReports = reports.map((report: any) =>
                report.id === selectedReport.id ? { ...report, ...model } : report
            );
            setReports(updatedReports);

            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Report.UpdateSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Report has been successfully updated.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        }
    };

    const deleteReport = async () => {
        try {
            await ReportService.remove(selectedReport.id);

            const updatedReports = reports.filter(
                (report: any) => report.id !== selectedReport.id
            );
            setReports(updatedReports);

            NotificationsUtil.openNotificationDialog({
                description: t(
                    "Page.Configuration.ProjectSetup.Notifications.Report.DeleteSuccessDescription",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Report has been successfully deleted.",
                    }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
            onAddClick(null);
            setIsDirty(false);
        } catch (error: any) {
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        }
    };

    const resetEntity = () => {
        setSelectedEntity(tableData.find((x: any) => x.id === selectedEntity.id));
    };

    const resetGroupCode = () => {
        setSelectedGroupCode(
            tableData.find((x: any) => x.id === selectedGroupCode.id)
        );
    };

    const resetDatabase = () => {
        setSelectedDatabase(
            tableData.find((x: any) => x.id === selectedDatabase.id)
        );
    };

    const resetEnvironment = () => {
        setSelectedEnvironment(
            tableData.find((x: any) => x.id === selectedEnvironment.id)
        );
    };

    const resetDataSource = () => {
        setSelectedDataSource(
            tableData.find((x: any) => x.id === selectedDataSource.id)
        );
    };

    const resetReport = () => {
        setSelectedReport(reports.find((x: any) => x.id === selectedReport.id));
    };

    const resetSystem = () => {
        updateSystemForm.setFieldsValue(selectedSystem);
    }

    const onSelectedEntityDefaultImportDatabaseChange = (value: any) => {
        setSelectedEntity({ ...selectedEntity, defaultImportDatabase: value });
    };

    const onSelectedEntityDefaultLegacyDatabaseChange = (value: any) => {
        setSelectedEntity({ ...selectedEntity, defaultLegacyDatabase: value });
    };

    const onSelectedEntityDefaultValidationDatabaseChange = (value: any) => {
        setSelectedEntity({ ...selectedEntity, defaultValidationDatabase: value });
    };

    const onSelectedEntityDefaultLoadFileDatabaseChange = (value: any) => {
        setSelectedEntity({ ...selectedEntity, defaultLoadFileDatabase: value });
    };

    const onSelectedSourceSystemsChange = (value: number[]) => {
        setSelectedEntity({ ...selectedEntity, sourceSystemIds: value });
    }

    const onSelectedTargetSystemChange = (value: number) => {
        setSelectedEntity({ ...selectedEntity, targetSystemId: value });
    }

    const onSelectedLegacySystemChange = (value: number) => {
        setSelectedEntity({ ...selectedEntity, legacySystemId: value });
    }

    const onSelectedEntityAlwaysShowChange = (event: CheckboxChangeEvent) => {
        setSelectedEntity({ ...selectedEntity, alwaysShow: event.target.checked });
    };

    const onSelectedEntityDescriptionChange: React.ChangeEventHandler<
        HTMLTextAreaElement
    > = (event) => {
        setSelectedEntity({ ...selectedEntity, description: event.target.value });
    };

    const onSelectedDataSourceTypeChange = (value: any) => {
        setSelectedDataSource({
            ...selectedDataSource,
            sourceTypeId: value,
        });
    };

    const testDatabaseConnection = () => {
        const model = {
            server: selectedDataSource.server,
            database: selectedDataSource.database,
            user: selectedDataSource.username,
            password: selectedDataSource.password,
            projectSourceId: selectedDataSource.id.toString(),
        };

        ExtractionService.testConnection(model)
            .then((response: any) => {
                const data = response.data;
                setTestDatabaseConnectionState(data);
            })
            .catch((error: any) => {
                console.log(error);
                setTestDatabaseConnectionState(false);
            });
    };

    const dropdownOptions = [
        {
            label: t("Page.Configuration.ProjectSetup.DropdownItems.Databases", {
                lngs: i18n.languages,
                defaultValue: "Databases",
            }),
            value: PROJECT_TYPE.DATABASE,
        },
        {
            label: t("Page.Configuration.ProjectSetup.DropdownItems.Environments", {
                lngs: i18n.languages,
                defaultValue: "Environments",
            }),
            value: PROJECT_TYPE.ENVIRONMENT,
        },
        {
            label: t("Page.Configuration.ProjectSetup.DropdownItems.Entities", {
                lngs: i18n.languages,
                defaultValue: "Entities",
            }),
            value: PROJECT_TYPE.ENTITY,
        },
        {
            label: t("Page.Configuration.ProjectSetup.DropdownItems.GroupCodes", {
                lngs: i18n.languages,
                defaultValue: "Group Codes",
            }),
            value: PROJECT_TYPE.GROUP_CODE,
        },
        {
            label: t("Page.Configuration.ProjectSetup.DropdownItems.DataSources", {
                lngs: i18n.languages,
                defaultValue: "Data Sources",
            }),
            value: PROJECT_TYPE.DATA_SOURCE,
        },
        {
            label: t("Page.Configurarion.ProjectSetup.DropdownItems.Reporting", {
                lngs: i18n.languages,
                defaultValue: "Reporting",
            }),
            value: PROJECT_TYPE.REPORTING,
        },
        {
            label: t("Page.Configuration.ProjectSetup.DropdownItems.System", {
                lngs: i18n.languages,
                defaultValue: "System",
            }),
            value: PROJECT_TYPE.SYSTEM,
        }
    ];

    return (
        <div>
            <PageHead
                title={t("Page.Configuration.ProjectSetup.Headers.ProjectSetup", {
                    lngs: i18n.languages,
                    defaultValue: "Project setup",
                })}
                icon={<ControlOutlined />}
                routes={routes}
                groupCodes={[]}
                entities={[]}
                operations={[]}
                selectedGroupCode={selectedGroupCode}
                selectedEntity={selectedEntity}
                selectedOperation={undefined}
                setSelectedGroupCode={undefined}
                setSelectedEntity={undefined}
                setSelectedOperation={undefined}
                setSelectGroupCodeDisabled={true}
                setSelectEntityDisabled={true}
                setSelectOperationDisabled={true}
                mainAction={[]}
                otherActions={[]}
                setActionsDisabled={true}
            />
            <div className="body-content">
                <div className="select-container">
                    <div className="select-header">
                        <Select
                            autoFocus
                            style={{ flex: "2 1 0%" }}
                            placeholder={t(
                                "Page.Configuration.ProjectSetup.Placeholders.SelectProject",
                                { lngs: i18n.languages, defaultValue: "Select project" }
                            )}
                            onChange={handleOptionChange}
                            showSearch={true}
                            showArrow={true}
                            allowClear={true}
                            options={dropdownOptions}
                            filterOption={(inputValue, option) =>
                                option!.label
                                    .toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            filterSort={(optionA, optionB) =>
                                (optionA!.label as unknown as string)
                                    .toLowerCase()
                                    .localeCompare(
                                        (optionB!.label as unknown as string).toLowerCase()
                                    )
                            }
                        ></Select>
                        <Button
                            onClick={onAddClick}
                            icon={<PlusOutlined />}
                            className={selectedOption ? "active-btn" : ""}
                            disabled={!selectedOption}
                        />
                    </div>
                    <Divider />
                    <div className="form-container">
                        {tableData && tableData.length > 0 && (
                            <Menu
                                items={tableData.map((item: any) => {
                                    return {
                                        key: item.id,
                                        label: item.name ? item.name : item.code,
                                    };
                                })}
                                selectedKeys={[selectedItem?.id.toString()]}
                                onClick={handleOptionMenuClick}
                            />
                        )}
                        {(!tableData || tableData.length <= 0) &&
                            (isEntitiesLoading ||
                                isGroupCodesLoading ||
                                isDatabasesLoading ||
                                isEnvironmentsLoading ||
                                isDataSourcesLoading) && (
                                <div className="loadingContainer">
                                    <Spin />
                                </div>
                            )}
                        {(!tableData || tableData.length <= 0) &&
                            !isEntitiesLoading &&
                            !isGroupCodesLoading &&
                            !isDatabasesLoading &&
                            !isEnvironmentsLoading &&
                            !isDataSourcesLoading && (
                                <Empty
                                    description={t(
                                        "Page.Configuration.ProjectSetup.Tutorial.GetStarted",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue:
                                                "Please select a project object to get started",
                                        }
                                    )}
                                />
                            )}
                    </div>
                </div>
                {!selectedOption && (
                    <div className="empty-container">
                        <Empty description={false} />
                    </div>
                )}
                {selectedOption === PROJECT_TYPE.ENTITY && !selectedEntity && (
                    <div className="empty-container">
                        <Empty
                            description={t(
                                "Page.Configuration.ProjectSetup.Tutorial.EntitiesAddOrSelectItem",
                                {
                                    lngs: i18n.languages,
                                    defaultValue:
                                        "Select an existing entity or create a new one to get started",
                                }
                            )}
                        />
                    </div>
                )}
                {selectedOption === PROJECT_TYPE.GROUP_CODE && !selectedGroupCode && (
                    <div className="empty-container">
                        <Empty
                            description={t(
                                "Page.Configuration.ProjectSetup.Tutorial.GroupCodesAddOrSelectItem",
                                {
                                    lngs: i18n.languages,
                                    defaultValue:
                                        "Select an existing group code or create a new one to get started",
                                }
                            )}
                        />
                    </div>
                )}
                {selectedOption === PROJECT_TYPE.DATABASE && !selectedDatabase && (
                    <div className="empty-container">
                        <Empty
                            description={t(
                                "Page.Configuration.ProjectSetup.Tutorial.DatabasesAddOrSelectItem",
                                {
                                    lngs: i18n.languages,
                                    defaultValue:
                                        "Select an existing database or create a new one to get started",
                                }
                            )}
                        />
                    </div>
                )}
                {selectedOption === PROJECT_TYPE.ENVIRONMENT &&
                    !selectedEnvironment && (
                        <div className="empty-container">
                            <Empty
                                description={t(
                                    "Page.Configuration.ProjectSetup.Tutorial.EnvironmentsAddOrSelectItem",
                                    {
                                        lngs: i18n.languages,
                                        defaultValue:
                                            "Select an existing environment or create a new one to get started",
                                    }
                                )}
                            />
                        </div>
                    )}
                {selectedOption === PROJECT_TYPE.DATA_SOURCE && !selectedDataSource && (
                    <div className="empty-container">
                        <Empty
                            description={t(
                                "Page.Configuration.ProjectSetup.Tutorial.DataSourceAddOrSelectItem",
                                {
                                    lngs: i18n.languages,
                                    defaultValue:
                                        "Select an existing data source or create a new one to get started",
                                }
                            )}
                        />
                    </div>
                )}
                {selectedEntity && selectedEntity.id && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedEntity.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Update", {
                                            lngs: i18n.languages,
                                            defaultValue: "Update",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Popconfirm
                                    style={{ width: "400px" }}
                                    placement="topRight"
                                    title={
                                        <div
                                            style={{
                                                width: "400px",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {t(
                                                "Page.Configuration.ProjectSetup.Warnings.EntityDelete",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue:
                                                        "Are you really sure that you want to delete this entity? This will delete all data related to it.",
                                                }
                                            )}
                                        </div>
                                    }
                                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                                    onConfirm={() => deleteEntity()}
                                    okText={t("General.Actions.Yes", {
                                        lngs: i18n.languages,
                                        defaultValue: "Yes",
                                    })}
                                    cancelText={t("General.Actions.No", {
                                        lngs: i18n.languages,
                                        defaultValue: "No",
                                    })}
                                >
                                    <Button
                                        type="ghost"
                                        size="small"
                                        icon={<DeleteOutlined />}
                                        loading={deleteEntityLoading}
                                    >
                                        {t("General.Labels.Delete", {
                                            lngs: i18n.languages,
                                            defaultValue: "Delete",
                                        })}
                                    </Button>
                                </Popconfirm>
                                <Button
                                    onClick={resetEntity}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateEntityDisabled ? "update-button" : ""}
                                    disabled={updateEntityDisabled}
                                    onClick={updateEntity}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateEntityLoading}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form
                                layout="vertical"
                                size="small"
                                style={{ width: "50%" }}
                                disabled={!userHasPermissions.write}
                            >
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.Name",
                                        { lngs: i18n.languages, defaultValue: "Name:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.Name",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                    required
                                >
                                    <Input
                                        disabled={true}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedEntity?.name}
                                        onChange={onSelectedEntityNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.Description",
                                        { lngs: i18n.languages, defaultValue: "Description:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.Description",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <TextArea
                                        value={selectedEntity?.description}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        rows={6}
                                        allowClear
                                        onChange={onSelectedEntityDescriptionChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.ImportDefaultDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Import database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultImportDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultImportDatabase}
                                        onChange={onSelectedEntityDefaultImportDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.DefaultLegacyDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Legacy database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultLegacyDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultLegacyDatabase}
                                        onChange={onSelectedEntityDefaultLegacyDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.DefaultValidationDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Validation database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultValidationDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultValidationDatabase}
                                        onChange={onSelectedEntityDefaultValidationDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.DefaultLoadFileDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Load File database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultLoadFileDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultLoadFileDatabase}
                                        onChange={onSelectedEntityDefaultLoadFileDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.SourceSystems",
                                        { lngs: i18n.languages, defaultValue: "Source systems:" }
                                    )}>
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        options={entitySystems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedEntity?.sourceSystemIds}
                                        onChange={onSelectedSourceSystemsChange}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOptions", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select options",
                                        })!}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.TargetSystem",
                                        { lngs: i18n.languages, defaultValue: "Target system:" }
                                    )}>
                                    <Select
                                        showSearch
                                        options={entitySystems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedEntity?.targetSystemId}
                                        onChange={onSelectedTargetSystemChange}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })!}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.legacySystem",
                                        { lngs: i18n.languages, defaultValue: "System used for legacy:" }
                                    )}>
                                    <Select
                                        showSearch
                                        options={entitySystems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedEntity?.legacySystemId}
                                        onChange={onSelectedLegacySystemChange}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })!}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Checkbox
                                        checked={selectedEntity.alwaysShow}
                                        onChange={onSelectedEntityAlwaysShowChange}
                                    >
                                        {
                                            t(
                                                "Page.Configuration.ProjectSetup.Labels.Entity.AlwaysShow",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Always show",
                                                }
                                            )!
                                        }
                                    </Checkbox>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedEntity && !selectedEntity.id && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedEntity.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={resetEntity}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateEntityDisabled ? "update-button" : ""}
                                    onClick={createEntity}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateEntityLoading}
                                >
                                    {t("General.Labels.Create", {
                                        lngs: i18n.languages,
                                        defaultValue: "Create",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.Name",
                                        { lngs: i18n.languages, defaultValue: "Name:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.Name",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                    required
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedEntity?.name}
                                        onChange={onSelectedEntityNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.Description",
                                        { lngs: i18n.languages, defaultValue: "Description:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.Description",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <TextArea
                                        value={selectedEntity?.description}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        rows={6}
                                        allowClear
                                        onChange={onSelectedEntityDescriptionChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.ImportDefaultDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Import database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultImportDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultImportDatabase}
                                        onChange={onSelectedEntityDefaultImportDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.DefaultLegacyDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Legacy database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultLegacyDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultLegacyDatabase}
                                        onChange={onSelectedEntityDefaultLegacyDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.DefaultValidationDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Validation database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultValidationDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultValidationDatabase}
                                        onChange={onSelectedEntityDefaultValidationDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.DefaultLoadFileDatabase",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Default Load File database:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Entities.DefaultLoadFileDatabase",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={
                                            preferences.find(
                                                (x) =>
                                                    x.componentId ===
                                                    components.find(
                                                        (x: any) => x.name === GLOBAL_COMPONENT
                                                    )?.id &&
                                                    x.key ===
                                                    GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT &&
                                                    x.object === "Application"
                                            )
                                                ? preferences.find(
                                                    (x) =>
                                                        x.componentId ===
                                                        components.find(
                                                            (x: any) => x.name === GLOBAL_COMPONENT
                                                        )?.id &&
                                                        x.key ===
                                                        GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT &&
                                                        x.object === "Application"
                                                ).value
                                                : t("General.Placeholders.SelectOption", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Select option",
                                                })
                                        }
                                        options={entityDatabases.map((x: any) => {
                                            return {
                                                label: x.name,
                                                value: x.name,
                                            };
                                        })}
                                        value={selectedEntity.defaultLoadFileDatabase}
                                        onChange={onSelectedEntityDefaultLoadFileDatabaseChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.SourceSystems",
                                        { lngs: i18n.languages, defaultValue: "Source systems:" }
                                    )}>
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        options={entitySystems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedEntity?.sourceSystemIds}
                                        onChange={onSelectedSourceSystemsChange}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOptions", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select options",
                                        })!}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.TargetSystem",
                                        { lngs: i18n.languages, defaultValue: "Target system:" }
                                    )}>
                                    <Select
                                        showSearch
                                        options={entitySystems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedEntity?.targetSystemId}
                                        onChange={onSelectedTargetSystemChange}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })!}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Entities.legacySystem",
                                        { lngs: i18n.languages, defaultValue: "System used for legacy:" }
                                    )}>
                                    <Select
                                        showSearch
                                        options={entitySystems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedEntity?.legacySystemId}
                                        onChange={onSelectedLegacySystemChange}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })!}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Checkbox
                                        checked={selectedEntity.alwaysShow}
                                        onChange={onSelectedEntityAlwaysShowChange}
                                    >
                                        {
                                            t(
                                                "Page.Configuration.ProjectSetup.Labels.Entity.AlwaysShow",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Always show",
                                                }
                                            )!
                                        }
                                    </Checkbox>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedGroupCode && selectedGroupCode.id !== "New Group code" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedGroupCode.code} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Update", {
                                            lngs: i18n.languages,
                                            defaultValue: "Update",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Popconfirm
                                    style={{ width: "400px" }}
                                    placement="topRight"
                                    title={
                                        <div
                                            style={{
                                                width: "400px",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {t(
                                                "Page.Configuration.ProjectSetup.Warnings.GroupCodeDelete",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue:
                                                        "Are you really sure that you want to delete this group code? This will delete all data related to it.",
                                                }
                                            )}
                                        </div>
                                    }
                                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                                    onConfirm={() => deleteGroupCode()}
                                    // onCancel={() => cancel}
                                    okText={t("General.Actions.Yes", {
                                        lngs: i18n.languages,
                                        defaultValue: "Yes",
                                    })}
                                    cancelText={t("General.Actions.No", {
                                        lngs: i18n.languages,
                                        defaultValue: "No",
                                    })}
                                >
                                    <Button
                                        // onClick={deleteGroupCode}
                                        type="ghost"
                                        size="small"
                                        icon={<DeleteOutlined />}
                                        loading={deleteGroupCodeLoading}
                                    >
                                        {t("General.Labels.Delete", {
                                            lngs: i18n.languages,
                                            defaultValue: "Delete",
                                        })}
                                    </Button>
                                </Popconfirm>
                                <Button
                                    onClick={resetGroupCode}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateGroupCodeDisabled ? "update-button" : ""}
                                    disabled={updateGroupCodeDisabled}
                                    onClick={updateGroupCode}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateGroupCodeLoading}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form
                                layout="vertical"
                                size="small"
                                style={{ width: "50%" }}
                                disabled={!userHasPermissions.write}
                            >
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.Code",
                                        { lngs: i18n.languages, defaultValue: "Code:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.Code",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        disabled={true}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedGroupCode?.code}
                                        onChange={onSelectedGroupCodeCodeChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.Label",
                                        { lngs: i18n.languages, defaultValue: "Label:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.Label",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedGroupCode?.label}
                                        onChange={onSelectedGroupCodeLabelChange}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Checkbox
                                        checked={selectedGroupCode.active}
                                        onChange={onSelectedGroupCodeIsActiveChange}
                                    >
                                        {
                                            t(
                                                "Page.Configuration.ProjectSetup.Labels.GroupCodes.IsActive",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Active",
                                                }
                                            )!
                                        }
                                    </Checkbox>
                                </Form.Item>
                                <Form.Item>
                                    <Checkbox
                                        checked={selectedGroupCode.code === defaultGroupCode}
                                        onChange={onSelectedDefaultGroupCodeIsActiveChange}
                                    >
                                        {
                                            t(
                                                "Page.Configuration.ProjectSetup.Labels.DefaultGroupCode.IsActive",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Set as my default Group Code",
                                                }
                                            )!
                                        }
                                    </Checkbox>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.StartDate",
                                        { lngs: i18n.languages, defaultValue: "Start Date:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.StartDate",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        value={selectedGroupCode.startDate}
                                        onChange={onSelectedGroupCodeStartDateChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.GoLive",
                                        { lngs: i18n.languages, defaultValue: "Go Live:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.GoLive",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        value={selectedGroupCode.goLiveDate}
                                        onChange={onSelectedGroupCodeGoLiveDateChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.EndDate",
                                        { lngs: i18n.languages, defaultValue: "End Date:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.EndDate",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        value={selectedGroupCode.endDate}
                                        onChange={onSelectedGroupCodeEndDateChange}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedGroupCode && selectedGroupCode.id === "New Group code" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedGroupCode.code} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={resetGroupCode}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateGroupCodeDisabled ? "update-button" : ""}
                                    onClick={createGroupCode}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateGroupCodeLoading}
                                >
                                    {t("General.Labels.Create", {
                                        lngs: i18n.languages,
                                        defaultValue: "Create",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.Code",
                                        { lngs: i18n.languages, defaultValue: "Code:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.Code",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedGroupCode?.code}
                                        onChange={onSelectedGroupCodeCodeChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.Label",
                                        { lngs: i18n.languages, defaultValue: "Label:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.Label",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedGroupCode?.label}
                                        onChange={onSelectedGroupCodeLabelChange}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Checkbox
                                        checked={selectedGroupCode.active}
                                        onChange={onSelectedGroupCodeIsActiveChange}
                                    >
                                        {
                                            t(
                                                "Page.Configuration.ProjectSetup.Labels.GroupCodes.IsActive",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Active",
                                                }
                                            )!
                                        }
                                    </Checkbox>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.StartDate",
                                        { lngs: i18n.languages, defaultValue: "Start Date:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.StartDate",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        value={selectedGroupCode.startDate}
                                        onChange={onSelectedGroupCodeStartDateChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.GoLive",
                                        { lngs: i18n.languages, defaultValue: "Go Live:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.GoLive",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        value={selectedGroupCode.goLiveDate}
                                        onChange={onSelectedGroupCodeGoLiveDateChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.GroupCodes.EndDate",
                                        { lngs: i18n.languages, defaultValue: "End Date:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.GroupCodes.EndDate",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        value={selectedGroupCode.endDate}
                                        onChange={onSelectedGroupCodeEndDateChange}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedDatabase && selectedDatabase.id === "New Database" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedDatabase.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={resetDatabase}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateDatabaseDisabled ? "update-button" : ""}
                                    onClick={createDatabase}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateDatabaseLoading}
                                >
                                    {t("General.Labels.Create", {
                                        lngs: i18n.languages,
                                        defaultValue: "Create",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Databases.Name",
                                        { lngs: i18n.languages, defaultValue: "Name:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Databases.Name",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedDatabase?.name}
                                        onChange={onSelectedDatabaseNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Databases.Label",
                                        { lngs: i18n.languages, defaultValue: "Label:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Databases.Label",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedDatabase?.description}
                                        onChange={onSelectedDatabaseDescriptionChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.IsDefaultImportDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Import Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.IsDefaultImportDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to store imported sources",
                                            }
                                        )!
                                    }
                                    style={{ marginBottom: "0px!important" }}
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultImportDB}
                                        onChange={onSelectedDatabaseIsDefaultImportDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <span style={{ color: "grey" }}>
                                    Current default:{" "}
                                    {databases.find((x: any) => x.isDefaultImportDB)?.name}
                                </span>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.isDefaultLegacyDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Legacy Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.isDefaultLegacyDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to create new legacy tables",
                                            }
                                        )!
                                    }
                                    style={{
                                        marginBottom: "0px!important",
                                        marginTop: "15px!important",
                                    }}
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultLegacyDB}
                                        onChange={onSelectedDatabaseIsDefaultLegacyDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <span style={{ color: "grey" }}>
                                    Current default:{" "}
                                    {databases.find((x: any) => x.isDefaultLegacyDB)?.name}
                                </span>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.IsDefaultIValidationDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Validation Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.IsDefaultIValidationDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to create new validation tables",
                                            }
                                        )!
                                    }
                                    style={{
                                        marginBottom: "0px!important",
                                        marginTop: "15px!important",
                                    }}
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultValidationDB}
                                        onChange={onSelectedDatabaseIsDefaultValidationDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <span style={{ color: "grey" }}>
                                    Current default:{" "}
                                    {databases.find((x: any) => x.isDefaultValidationDB)?.name}
                                </span>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.IsDefaultLoadfileDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Load File Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.IsDefaultLoadfileDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to create new load file tables",
                                            }
                                        )!
                                    }
                                    style={{
                                        marginBottom: "0px!important",
                                        marginTop: "15px!important",
                                    }}
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultLoadfileDB}
                                        onChange={onSelectedDatabaseIsDefaultLoadfileDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <span style={{ color: "grey" }}>
                                    Current default:{" "}
                                    {databases.find((x: any) => x.isDefaultLoadfileDB)?.name}
                                </span>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedDatabase && selectedDatabase.id !== "New Database" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedDatabase.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Update", {
                                            lngs: i18n.languages,
                                            defaultValue: "Update",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={deleteDatabase}
                                    type="ghost"
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    loading={deleteDatabaseLoading}
                                >
                                    {t("General.Labels.Delete", {
                                        lngs: i18n.languages,
                                        defaultValue: "Delete",
                                    })}
                                </Button>
                                <Button
                                    onClick={resetDatabase}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateDatabaseDisabled ? "update-button" : ""}
                                    disabled={updateDatabaseDisabled}
                                    onClick={updateDatabase}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateDatabaseLoading}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Databases.Name",
                                        { lngs: i18n.languages, defaultValue: "Name:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Databases.Name",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedDatabase?.name}
                                        onChange={onSelectedDatabaseNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Databases.Label",
                                        { lngs: i18n.languages, defaultValue: "Label:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Databases.Label",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedDatabase?.description}
                                        onChange={onSelectedDatabaseDescriptionChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.IsDefaultImportDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Import Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.IsDefaultImportDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to store imported sources",
                                            }
                                        )!
                                    }
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultImportDB}
                                        onChange={onSelectedDatabaseIsDefaultImportDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.isDefaultLegacyDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Legacy Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.isDefaultLegacyDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to create new legacy tables",
                                            }
                                        )!
                                    }
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultLegacyDB}
                                        onChange={onSelectedDatabaseIsDefaultLegacyDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.IsDefaultIValidationDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Validation Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.IsDefaultIValidationDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to create new validation tables",
                                            }
                                        )!
                                    }
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultValidationDB}
                                        onChange={onSelectedDatabaseIsDefaultValidationDbChange}
                                    ></Checkbox>
                                </Form.Item>
                                <Form.Item
                                    className="checkbox-form-item"
                                    label={
                                        t(
                                            "Page.Configuration.ProjectSetup.Labels.Databases.IsDefaultLoadfileDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Set as default Load File Database?",
                                            }
                                        )!
                                    }
                                    tooltip={
                                        t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Databases.IsDefaultLoadfileDB",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Use this database to create new load file tables",
                                            }
                                        )!
                                    }
                                >
                                    <Checkbox
                                        checked={selectedDatabase.isDefaultLoadfileDB}
                                        onChange={onSelectedDatabaseIsDefaultLoadfileDbChange}
                                    ></Checkbox>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedEnvironment &&
                    selectedEnvironment.id === "New Environment" && (
                        <div className="data-container">
                            <div className="title-actions">
                                <Breadcrumb>
                                    <Breadcrumb.Item>
                                        {selectedEnvironment.name} /{" "}
                                        <span style={{ color: "#7D7D7D" }}>
                                            {t("General.Labels.Create", {
                                                lngs: i18n.languages,
                                                defaultValue: "Create",
                                            })}
                                        </span>
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                                <div className="action-buttons">
                                    <Button
                                        onClick={resetEnvironment}
                                        type="ghost"
                                        size="small"
                                        icon={<SyncOutlined />}
                                    >
                                        {t("General.Labels.Reset", {
                                            lngs: i18n.languages,
                                            defaultValue: "Reset",
                                        })}
                                    </Button>
                                    <Button
                                        className={
                                            !updateEnvironmentDisabled ? "update-button" : ""
                                        }
                                        onClick={createEnvironment}
                                        size="small"
                                        icon={<CheckOutlined />}
                                        loading={updateEnvironmentLoading}
                                    >
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </Button>
                                </div>
                            </div>
                            <Divider />
                            <div className="form-content">
                                <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                    <Form.Item
                                        label={t(
                                            "Page.Configuration.ProjectSetup.Labels.Environments.Name",
                                            { lngs: i18n.languages, defaultValue: "Name:" }
                                        )}
                                        tooltip={t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Environments.Name",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <Input
                                            placeholder={
                                                t("General.Placeholders.EnterValue", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                })!
                                            }
                                            value={selectedEnvironment?.name}
                                            onChange={onSelectedEnvironmentNameChange}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t(
                                            "Page.Configuration.ProjectSetup.Labels.Environments.Label",
                                            { lngs: i18n.languages, defaultValue: "Label:" }
                                        )}
                                        tooltip={t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Environments.Label",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <Input
                                            placeholder={
                                                t("General.Placeholders.EnterValue", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                })!
                                            }
                                            value={selectedEnvironment?.description}
                                            onChange={onSelectedEnvironmentDescriptionChange}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Default Environment">
                                        <Checkbox
                                            checked={selectedEnvironment?.isDefault}
                                            onChange={onSelectedEnvironmentIsDefaultChange}
                                        />
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    )}
                {selectedEnvironment &&
                    selectedEnvironment.id !== "New Environment" && (
                        <div className="data-container">
                            <div className="title-actions">
                                <Breadcrumb>
                                    <Breadcrumb.Item>
                                        {selectedEnvironment.name} /{" "}
                                        <span style={{ color: "#7D7D7D" }}>
                                            {t("General.Labels.Update", {
                                                lngs: i18n.languages,
                                                defaultValue: "Update",
                                            })}
                                        </span>
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                                <div className="action-buttons">
                                    <Button
                                        onClick={deleteEnvironment}
                                        type="ghost"
                                        size="small"
                                        icon={<DeleteOutlined />}
                                        loading={deleteEnvironmentLoading}
                                    >
                                        {t("General.Labels.Delete", {
                                            lngs: i18n.languages,
                                            defaultValue: "Delete",
                                        })}
                                    </Button>
                                    <Button
                                        onClick={resetEnvironment}
                                        type="ghost"
                                        size="small"
                                        icon={<SyncOutlined />}
                                    >
                                        {t("General.Labels.Reset", {
                                            lngs: i18n.languages,
                                            defaultValue: "Reset",
                                        })}
                                    </Button>
                                    <Button
                                        className={
                                            !updateEnvironmentDisabled ? "update-button" : ""
                                        }
                                        disabled={updateEnvironmentDisabled}
                                        onClick={updateEnvironment}
                                        size="small"
                                        icon={<CheckOutlined />}
                                        loading={updateEnvironmentLoading}
                                    >
                                        {t("General.Labels.Update", {
                                            lngs: i18n.languages,
                                            defaultValue: "Update",
                                        })}
                                    </Button>
                                </div>
                            </div>
                            <Divider />
                            <div className="form-content">
                                <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                    <Form.Item
                                        label={t(
                                            "Page.Configuration.ProjectSetup.Labels.Environments.Name",
                                            { lngs: i18n.languages, defaultValue: "Name:" }
                                        )}
                                        tooltip={t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Environments.Name",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <Input
                                            placeholder={
                                                t("General.Placeholders.EnterValue", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                })!
                                            }
                                            value={selectedEnvironment?.name}
                                            onChange={onSelectedEnvironmentNameChange}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t(
                                            "Page.Configuration.ProjectSetup.Labels.Environments.Label",
                                            { lngs: i18n.languages, defaultValue: "Label:" }
                                        )}
                                        tooltip={t(
                                            "Page.Configuration.ProjectSetup.Tooltips.Environments.Label",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <Input
                                            placeholder={
                                                t("General.Placeholders.EnterValue", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                })!
                                            }
                                            value={selectedEnvironment?.description}
                                            onChange={onSelectedEnvironmentDescriptionChange}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Default Environment">
                                        <Checkbox
                                            checked={selectedEnvironment?.isDefault}
                                            onChange={onSelectedEnvironmentIsDefaultChange}
                                        />
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    )}

                {selectedReport && selectedReport.id === "New Report" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedReport.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={resetReport}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateReportDisabled ? "update-button" : ""}
                                    onClick={createReport}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateReportLoading}
                                >
                                    {t("General.Labels.Create", {
                                        lngs: i18n.languages,
                                        defaultValue: "Create",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Reports.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Name:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Reports.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedReport?.name}
                                        onChange={onSelectedReportNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Reports.PowerBIURL",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "PowerBI URL:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Reports.PowerBIURL",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedReport?.url}
                                        onChange={onSelectedReportURLChange}
                                    />
                                    <Form.Item
                                        label={
                                            t(
                                                "Page.Configuration.ProjectSetup.Tooltips.Reports.IsDefault",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Default Report",
                                                }
                                            )!
                                        }
                                    >
                                        <Checkbox
                                            checked={selectedReport?.isReport}
                                            onChange={onSelectedReportIsDefaultChange}
                                        />
                                    </Form.Item>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedReport && selectedReport.id !== "New Report" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedReport.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Update", {
                                            lngs: i18n.languages,
                                            defaultValue: "Update",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={deleteReport}
                                    type="ghost"
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    loading={deleteReportLoading}
                                >
                                    {t("General.Labels.Delete", {
                                        lngs: i18n.languages,
                                        defaultValue: "Delete",
                                    })}
                                </Button>
                                <Button
                                    onClick={resetReport}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateReportDisabled ? "update-button" : ""}
                                    disabled={updateReportDisabled}
                                    onClick={updateReport}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateReportLoading}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Reports.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Name:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Reports.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedReport?.name}
                                        onChange={onSelectedReportNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.Reports.PowerBIURL",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "PowerBI URL:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.Reports.PowerBIURL",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedReport?.url}
                                        onChange={onSelectedReportURLChange}
                                    />
                                    <Form.Item
                                        label={
                                            t(
                                                "Page.Configuration.ProjectSetup.Tooltips.Reports.IsDefault",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Default Report",
                                                }
                                            )!
                                        }
                                    >
                                        <Checkbox
                                            checked={selectedReport?.isDefault}
                                            onChange={onSelectedReportIsDefaultChange}
                                        />
                                    </Form.Item>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedSystem && selectedSystem.id && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedSystem.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Update", {
                                            lngs: i18n.languages,
                                            defaultValue: "Update",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={deleteSystem}
                                    type="ghost"
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    loading={deleteReportLoading}
                                >
                                    {t("General.Labels.Delete", {
                                        lngs: i18n.languages,
                                        defaultValue: "Delete",
                                    })}
                                </Button>
                                <Button
                                    onClick={resetSystem}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateReportDisabled ? "update-button" : ""}
                                    disabled={updateReportDisabled}
                                    onClick={updateSystem}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={systemLoading}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form<System> form={updateSystemForm} layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    name="name"
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.System.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Name:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.System.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="description"
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.System.Description",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Description",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.System.Description",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }

                                    />
                                </Form.Item>
                                <Form.Item
                                    name="isPredefined"
                                    valuePropName="checked"
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.System.IsPredefined",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Checkbox
                                        disabled
                                    >
                                        {t(
                                            "Page.Configuration.ProjectSetup.Labels.System.IsPredefined",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Predefined",
                                            }
                                        )}
                                    </Checkbox>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}
                {selectedSystem && selectedSystem.id === null && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedSystem.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    className={!updateReportDisabled ? "update-button" : ""}
                                    onClick={createSystem}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={systemLoading}
                                >
                                    {t("General.Labels.Create", {
                                        lngs: i18n.languages,
                                        defaultValue: "Create",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form form={createSystemForm} layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    name="name"
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.System.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Name:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.System.Name",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="description"
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.System.Description",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Description:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.System.Description",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                )}

                {selectedDataSource && selectedDataSource.id === "New Data Source" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedDataSource.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={resetDataSource}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    className={!updateDataSourceDisabled ? "update-button" : ""}
                                    onClick={createDataSource}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateDataSourceLoading}
                                >
                                    {t("General.Labels.Create", {
                                        lngs: i18n.languages,
                                        defaultValue: "Create",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.DataSource.Name",
                                        { lngs: i18n.languages, defaultValue: "Name:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.DataSource.Name",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedDataSource?.name}
                                        onChange={onSelectedDataSourceNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.DataSource.SourceType",
                                        { lngs: i18n.languages, defaultValue: "Source Type:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourceType",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        filterSort={(optionA, optionB) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                        options={[
                                            {
                                                value: DATA_SOURCE_TYPE.SHAREPOINT,
                                                label: "SharePoint",
                                            },
                                            { value: DATA_SOURCE_TYPE.MSSQL, label: "SQL Database" },
                                            {
                                                value: DATA_SOURCE_TYPE.FILE_REPOSITORY,
                                                label: "File Repository",
                                            },
                                        ]}
                                        onChange={onSelectedDataSourceTypeChange}
                                        value={selectedDataSource.sourceTypeId}
                                    ></Select>
                                </Form.Item>
                                {selectedDataSource?.sourceTypeId ===
                                    DATA_SOURCE_TYPE.SHAREPOINT && (
                                        <>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SharePointUrl",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "SharePoint Url:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SharePointUrl",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.server}
                                                    onChange={onSelectedDataSourceServerChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.FolderRelativePath",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Folder Relative Path:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.FolderRelativePath",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.locationPath}
                                                    onChange={onSelectedDataSourceLocationPathChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.TenantId",
                                                    { lngs: i18n.languages, defaultValue: "Tenant Id:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.TenantId",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.tenantId}
                                                    onChange={onSelectedTenantIdChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.ClientId",
                                                    { lngs: i18n.languages, defaultValue: "Client Id:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.ClientId",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.clientId}
                                                    onChange={onSelectedClientIdChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.UserName",
                                                    { lngs: i18n.languages, defaultValue: "Username:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.UserName",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.username}
                                                    onChange={onSelectedDataSourceUsernameChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "Password:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input.Password
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.password}
                                                    onChange={onSelectedDataSourcePasswordChange}
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button
                                                    icon={<ExperimentOutlined />}
                                                    onClick={() => testSharePointConnection()}
                                                >
                                                    Test connection
                                                </Button>
                                                {testConnectionState && testConnectionState === true && (
                                                    <span style={{ color: "green" }}>
                                                        Test connection succeeded.
                                                    </span>
                                                )}
                                                {testConnectionState === false && (
                                                    <span style={{ color: "red" }}>
                                                        Test connection failed.
                                                    </span>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "Source Prefix:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.sourcePrefix}
                                                    onChange={onSelectedDataSourceSourcePrefixChange}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                                {selectedDataSource?.sourceTypeId ===
                                    DATA_SOURCE_TYPE.MSSQL && (
                                        <>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.ServerName",
                                                    { lngs: i18n.languages, defaultValue: "Server Name:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.ServerName",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.server}
                                                    onChange={onSelectedDataSourceServerChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Database",
                                                    { lngs: i18n.languages, defaultValue: "Database:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Database",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.database}
                                                    onChange={onSelectedDataSourceDatabaseChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Username",
                                                    { lngs: i18n.languages, defaultValue: "Username:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Username",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.username}
                                                    onChange={onSelectedDataSourceUsernameChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "Password:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input.Password
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.password}
                                                    onChange={onSelectedDataSourcePasswordChange}
                                                />
                                            </Form.Item>
                                            <Form.Item className={styles.mb10px}>
                                                <Button
                                                    icon={<ExperimentOutlined />}
                                                    onClick={() => testDatabaseConnection()}
                                                >
                                                    Test connection
                                                </Button>
                                                {testDatabaseConnectionState &&
                                                    testDatabaseConnectionState === true && (
                                                        <span style={{ color: "green" }}>
                                                            Test connection succeeded.
                                                        </span>
                                                    )}
                                                {testDatabaseConnectionState === false && (
                                                    <span style={{ color: "red" }}>
                                                        Test connection failed.
                                                    </span>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "Source Prefix:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.sourcePrefix}
                                                    onChange={onSelectedDataSourceSourcePrefixChange}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                                {selectedDataSource?.sourceTypeId ===
                                    DATA_SOURCE_TYPE.FILE_REPOSITORY && (
                                        <>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.LocationPath",
                                                    { lngs: i18n.languages, defaultValue: "Location Path:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.LocationPath",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.locationPath}
                                                    onChange={onSelectedDataSourceLocationPathChange}
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button>Test connection</Button>
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "Source Prefix:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.sourcePrefix}
                                                    onChange={onSelectedDataSourceSourcePrefixChange}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                            </Form>
                        </div>
                    </div>
                )}
                {selectedDataSource && selectedDataSource.id !== "New Data Source" && (
                    <div className="data-container">
                        <div className="title-actions">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    {selectedDataSource.name} /{" "}
                                    <span style={{ color: "#7D7D7D" }}>
                                        {t("General.Labels.Create", {
                                            lngs: i18n.languages,
                                            defaultValue: "Create",
                                        })}
                                    </span>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                            <div className="action-buttons">
                                <Button
                                    onClick={resetDataSource}
                                    type="ghost"
                                    size="small"
                                    icon={<SyncOutlined />}
                                >
                                    {t("General.Labels.Reset", {
                                        lngs: i18n.languages,
                                        defaultValue: "Reset",
                                    })}
                                </Button>
                                <Button
                                    onClick={deleteDataSource}
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    loading={deleteDataSourceLoading}
                                >
                                    {t("General.Labels.Delete", {
                                        lngs: i18n.languages,
                                        defaultValue: "Delete",
                                    })}
                                </Button>
                                <Button
                                    className={!updateDataSourceDisabled ? "update-button" : ""}
                                    onClick={updateDataSource}
                                    size="small"
                                    icon={<CheckOutlined />}
                                    loading={updateDataSourceLoading}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                            </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                            <Form layout="vertical" size="small" style={{ width: "50%" }}>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.DataSource.Name",
                                        { lngs: i18n.languages, defaultValue: "Name:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.DataSource.Name",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Input
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        value={selectedDataSource?.name}
                                        onChange={onSelectedDataSourceNameChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.ProjectSetup.Labels.DataSource.SourceType",
                                        { lngs: i18n.languages, defaultValue: "Source Type:" }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourceType",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        allowClear
                                        style={{ width: "100%" }}
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        options={[
                                            {
                                                value: DATA_SOURCE_TYPE.SHAREPOINT,
                                                label: "SharePoint",
                                            },
                                            { value: DATA_SOURCE_TYPE.MSSQL, label: "SQL Database" },
                                            {
                                                value: DATA_SOURCE_TYPE.FILE_REPOSITORY,
                                                label: "File Repository",
                                            },
                                        ]}
                                        filterSort={(optionA, optionB) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                        onChange={onSelectedDataSourceTypeChange}
                                        value={selectedDataSource.sourceTypeId}
                                    ></Select>
                                </Form.Item>
                                {selectedDataSource?.sourceTypeId ===
                                    DATA_SOURCE_TYPE.SHAREPOINT && (
                                        <>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SharePointUrl",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "SharePoint Url:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SharePointUrl",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.server}
                                                    onChange={onSelectedDataSourceServerChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.FolderRelativePath",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Folder Relative Path:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.FolderRelativePath",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.locationPath}
                                                    onChange={onSelectedDataSourceLocationPathChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.TenantId",
                                                    { lngs: i18n.languages, defaultValue: "Tenant Id:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.TenantId",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.tenantId}
                                                    onChange={onSelectedTenantIdChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.ClientId",
                                                    { lngs: i18n.languages, defaultValue: "Client Id:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.ClientId",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.clientId}
                                                    onChange={onSelectedClientIdChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.UserName",
                                                    { lngs: i18n.languages, defaultValue: "Username:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.UserName",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.username}
                                                    onChange={onSelectedDataSourceUsernameChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "Password:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input.Password
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.password}
                                                    onChange={onSelectedDataSourcePasswordChange}
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button
                                                    icon={<ExperimentOutlined />}
                                                    onClick={() => testSharePointConnection()}
                                                >
                                                    Test connection
                                                </Button>
                                                {testConnectionState && testConnectionState === true && (
                                                    <span style={{ color: "green" }}>
                                                        Test connection succeeded.
                                                    </span>
                                                )}
                                                {testConnectionState === false && (
                                                    <span style={{ color: "red" }}>
                                                        Test connection failed.
                                                    </span>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "Source Prefix:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.sourcePrefix}
                                                    onChange={onSelectedDataSourceSourcePrefixChange}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                                {selectedDataSource?.sourceTypeId ===
                                    DATA_SOURCE_TYPE.MSSQL && (
                                        <>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.ServerName",
                                                    { lngs: i18n.languages, defaultValue: "Server Name:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.ServerName",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.server}
                                                    onChange={onSelectedDataSourceServerChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Database",
                                                    { lngs: i18n.languages, defaultValue: "Database:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Database",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.database}
                                                    onChange={onSelectedDataSourceDatabaseChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Username",
                                                    { lngs: i18n.languages, defaultValue: "Username:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Username",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.username}
                                                    onChange={onSelectedDataSourceUsernameChange}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "Password:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.Password",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input.Password
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.password}
                                                    onChange={onSelectedDataSourcePasswordChange}
                                                />
                                            </Form.Item>
                                            <Form.Item className={styles.mb10px}>
                                                <Button
                                                    icon={<ExperimentOutlined />}
                                                    onClick={() => testDatabaseConnection()}
                                                >
                                                    Test connection
                                                </Button>
                                                {testDatabaseConnectionState &&
                                                    testDatabaseConnectionState === true && (
                                                        <span style={{ color: "green" }}>
                                                            Test connection succeeded.
                                                        </span>
                                                    )}
                                                {testDatabaseConnectionState === false && (
                                                    <span style={{ color: "red" }}>
                                                        Test connection failed.
                                                    </span>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "Source Prefix:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.sourcePrefix}
                                                    onChange={onSelectedDataSourceSourcePrefixChange}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                                {selectedDataSource?.sourceTypeId ===
                                    DATA_SOURCE_TYPE.FILE_REPOSITORY && (
                                        <>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.LocationPath",
                                                    { lngs: i18n.languages, defaultValue: "Location Path:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.LocationPath",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.locationPath}
                                                    onChange={onSelectedDataSourceLocationPathChange}
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button>Test connection</Button>
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.ProjectSetup.Labels.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "Source Prefix:" }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.ProjectSetup.Tooltips.DataSource.SourcePrefix",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    value={selectedDataSource?.sourcePrefix}
                                                    onChange={onSelectedDataSourceSourcePrefixChange}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                            </Form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectSetup;
